// extracted by mini-css-extract-plugin
export default {"sp-logo-container":"SPLogo_sp-logo-container__smbTq","spt-title":"SPLogo_spt-title__zUN+s","second-word":"SPLogo_second-word__3m49S","sp-logo-wrap":"SPLogo_sp-logo-wrap__upclQ"};